import React from "react"
import { AutocompleteAjaxSeeker } from "@ui-seeker/core"


export default function AppMileageAutocomplete({ ...props }) {
    return <AutocompleteAjaxSeeker
		filterSelectedOptions={false} 
		label="Mileage"
		placeholder="No restrictions"
		{...props}
	/>
}